import * as React from "react";

import { cn } from "@/lib/utils";

type TagTone = "neutral" | "teal";

interface TagProps {
  tone?: TagTone;
  children: React.ReactNode;
  className?: string;
}

/** The unified pill — one neutral default + one teal selected state. */
const Tag = ({ tone = "neutral", children, className }: TagProps) => (
  <span
    className={cn(
      "inline-flex items-center whitespace-nowrap rounded-pill border px-3 py-[5px] text-[12.5px] font-medium",
      tone === "teal"
        ? "border-primary bg-primary-tint text-primary-pressed"
        : "border-border bg-card text-ink-700",
      className,
    )}
  >
    {children}
  </span>
);

interface TagRowProps {
  tags: React.ReactNode[];
  tone?: TagTone;
  className?: string;
}

const TagRow = ({ tags, tone, className }: TagRowProps) => (
  <div className={cn("flex flex-wrap gap-2", className)}>
    {tags.map((t, i) => (
      <Tag key={i} tone={tone}>
        {t}
      </Tag>
    ))}
  </div>
);

export { Tag, TagRow };
export default Tag;
